/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RocketWarehouseResVo
 */
export interface RocketWarehouseResVo {
    /**
     * 主键ID
     * @type {number}
     * @memberof RocketWarehouseResVo
     */
    id?: number;
    /**
     * 火箭仓库编码
     * @type {string}
     * @memberof RocketWarehouseResVo
     */
    code?: string;
    /**
     * 仓库韩文名称
     * @type {string}
     * @memberof RocketWarehouseResVo
     */
    nameKr?: string;
    /**
     * 仓库中文名称
     * @type {string}
     * @memberof RocketWarehouseResVo
     */
    nameCn?: string;
    /**
     * 收货人名称
     * @type {string}
     * @memberof RocketWarehouseResVo
     */
    receiverName?: string;
    /**
     * 电话号码
     * @type {string}
     * @memberof RocketWarehouseResVo
     */
    mobileNo?: string;
    /**
     * 邮政编码
     * @type {string}
     * @memberof RocketWarehouseResVo
     */
    zip?: string;
    /**
     * 韩文地址
     * @type {string}
     * @memberof RocketWarehouseResVo
     */
    addressKr?: string;
    /**
     * 中文地址
     * @type {string}
     * @memberof RocketWarehouseResVo
     */
    addressCn?: string;
    /**
     * 排序
     * @type {number}
     * @memberof RocketWarehouseResVo
     */
    sort?: number;
    /**
     * 是否可用 0不可用 1可用
     * @type {number}
     * @memberof RocketWarehouseResVo
     */
    enable?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof RocketWarehouseResVo
     */
    createTime?: string;
    /**
     * 更新时间
     * @type {string}
     * @memberof RocketWarehouseResVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the RocketWarehouseResVo interface.
 */
export function instanceOfRocketWarehouseResVo(value: object): value is RocketWarehouseResVo {
    return true;
}

export function RocketWarehouseResVoFromJSON(json: any): RocketWarehouseResVo {
    return RocketWarehouseResVoFromJSONTyped(json, false);
}

export function RocketWarehouseResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RocketWarehouseResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'nameKr': json['nameKr'] == null ? undefined : json['nameKr'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'addressKr': json['addressKr'] == null ? undefined : json['addressKr'],
        'addressCn': json['addressCn'] == null ? undefined : json['addressCn'],
        'sort': json['sort'] == null ? undefined : json['sort'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function RocketWarehouseResVoToJSON(json: any): RocketWarehouseResVo {
    return RocketWarehouseResVoToJSONTyped(json, false);
}

export function RocketWarehouseResVoToJSONTyped(value?: RocketWarehouseResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'nameKr': value['nameKr'],
        'nameCn': value['nameCn'],
        'receiverName': value['receiverName'],
        'mobileNo': value['mobileNo'],
        'zip': value['zip'],
        'addressKr': value['addressKr'],
        'addressCn': value['addressCn'],
        'sort': value['sort'],
        'enable': value['enable'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

